const getRandomColor = () => {
   return `rgb(${randColorNum()},${randColorNum()},${randColorNum()})`;
};

const randColorNum = () => {
   return Math.floor(Math.random() * 256);
}

export default getRandomColor;